import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AccessUserInfo, LabActionItemTabDetail, UserDetail, UserLocationFacility, unMappedLabTest } from 'src/app/models';
import { LabActionItemService, UserService } from 'src/app/services';
import { LoaderService } from 'src/app/services/loader.service';
import { CustomDatePipe } from 'src/app/pipes';
import { UserAction } from 'src/app/enum/user/userActions';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';

@Component({
  selector: 'bart-unmapped-lab-test',
  templateUrl: './unmapped-lab-test.component.html',
  styleUrls: ['./unmapped-lab-test.component.scss'],
  providers:[CustomDatePipe]
})
export class UnmappedLabTestComponent implements OnInit {
  @Input() selectedFacilityMasterId: number;
  @Input() userFacilities: UserLocationFacility[];
  @Input() tabDetails:LabActionItemTabDetail
  public userInfo: UserDetail;
  UnmappedLabTestActionItems: unMappedLabTest[];
  cols: any[];
  constructor(private router: Router,private customDatePipe :CustomDatePipe, private _labActionItemService: LabActionItemService, private _loaderService: LoaderService,private _userService: UserService)
   {this.userInfo = AccessUserInfo.getUserInfo(); }
 
  ngOnInit() {
    this.cols = [
      { field: 'TestDisplayName', header: 'Test ID | Name', display: 'table-cell', width: "48%" },
      { field: 'LastDateModified', header: 'Last Modified Date', display: 'table-cell', width: "48%" },
    ];
    this.getUnmappedLabTestActionItems();
      //#region User Action Audit
      this._userService.logUserAction({
        userName: this.userInfo.userName,
        userAction: UserAction.FILTER,
        screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
        screenPath: location.pathname,
        key: "FacilityMasterID",
        value: this.selectedFacilityMasterId,
        eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_UNMAPPED_LABS_TEST_GRID_LOADED
      });
      //#endregion
  }
  getUnmappedLabTestActionItems() {
    this._loaderService.show()
    let getNoLabRequestActionItemsParams = {
      "GETUNMAPPEDLABTESTACTIONITEMS": {
        facilitymasterid: this.selectedFacilityMasterId//this.facilityList.map(x => x.value).join(","),
      },
    }
    this.UnmappedLabTestActionItems = [];
    this._labActionItemService.getUnmappedLabTestActionItems(JSON.stringify(getNoLabRequestActionItemsParams)).subscribe(data => {
      this.UnmappedLabTestActionItems = data.getUnmappedLabTestActionItems;
      this.UnmappedLabTestActionItems.forEach(item =>
        {
          item.TestDisplayName=item.TestDisplayName
          item.LastDateModified=this.customDatePipe.transform(item.LastDateModified,"local","MM/dd/yyyy HH:mm");
          item.LastDateModifiedSort=new Date (this.customDatePipe.transform(item.LastDateModified,"local","MM/dd/yyyy HH:mm"));
        
        });
        if(this.UnmappedLabTestActionItems && this.tabDetails.RecordCount!=this.UnmappedLabTestActionItems.length)
        {
          this.tabDetails.RecordCount=this.UnmappedLabTestActionItems.length
        }
        this._loaderService.hide()

    },
      err => {
        this._loaderService.hide()
      });

  }
  navigateToLabMangaer(rowData) {
    this.router.navigate(['administrator/LabManager'], { queryParams: { index: 1 } });
     //#region User Action Audit
   this._userService.logUserAction({
    userName: this.userInfo.userName,
    userAction: UserAction.BUTTON_CLICKED,
    screenName: ScreenName.LABREQUEST,
    screenPath: location.pathname,
    key: "TestDisplayName",
    value: rowData.TestDisplayName,
    eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_UNMAPPED_LABS_TEST_GRID_EDIT_ICON_CLICKED
  });
  //#endregion
  }

  sortColumn(event) {
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.SORT,
      screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
      screenPath: location.pathname,
      key: event.field,
      value: event.order === 1 ? 'ASC' : 'DESC',
      eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_UNMAPPED_LABS_TEST_COLUMN_SORT
    });
    //#endregion
  }
paginate(event) {
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.PAGE_CHANGED,
      screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
      screenPath: location.pathname,
      key: 'Selected_Page_No',
      value: (event.first / event.rows) + 1,
      eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_UNMAPPED_LABS_TEST_PAGE_NO_CLICKED
    });
    //#endregion
  }




}